export default {
  en: {
    tabs: { overview: "Overview" },
    title: "Executive dashboard",
    subtitle: "Business value: outcomes, time saved and return on investment per agent and team.",
    groupBy: "Group by",
    byAgent: "By agent",
    byTeam: "By team",
    hours: "{{n}} h",
    times: "{{n}}×",
    roiChart: "Return on investment",
    scorecards: "Scorecards",
    col: { agent: "Agent", team: "Team" },
    kpi: { runs: "Runs", containment: "Containment", deflection: "Deflection", timeSaved: "Time saved", override: "Override rate", costPerOutcome: "Cost per outcome", roi: "ROI" },
    kpiHelp: {
      runs: "How many times agents were run in the period.",
      containment: "Of the cases agents worked on, the share they finished without handing over to a person.",
      deflection: "Of all new cases, the share agents resolved on their own — work people did not need to pick up.",
      timeSaved: "Estimated hours of human handling time saved by agents.",
      override: "How often a person changed or rejected what an agent proposed. Lower is better.",
      costPerOutcome: "Model cost divided by the number of resolved cases.",
      roi: "Value of the hours saved divided by the model cost. 3× means every unit spent saved three.",
    },
    kpiInfo: "What does {{kpi}} mean?",
    kpiShort: {
      containment: "Finished by agents without handing over to a person",
      deflection: "New requests agents settled on their own",
      override: "How often a person changed an agent's answer",
    },
    noData: "Not enough data yet",
    roiEmpty: "Not enough data yet. The return shows once agents have finished work and their cost is known.",
    empty: "No agent ran in this period. Try a longer period.",
  },
  ar: {
    tabs: { overview: "نظرة عامة" },
    title: "لوحة القيادة",
    subtitle: "القيمة للأعمال: النتائج والوقت الموفَّر والعائد على الاستثمار لكل وكيل وفريق.",
    groupBy: "التجميع حسب",
    byAgent: "حسب الوكيل",
    byTeam: "حسب الفريق",
    hours: "{{n}} ساعة",
    times: "{{n}}×",
    roiChart: "العائد على الاستثمار",
    scorecards: "بطاقات الأداء",
    col: { agent: "الوكيل", team: "الفريق" },
    kpi: { runs: "التشغيلات", containment: "الاحتواء", deflection: "تحويل الطلبات", timeSaved: "الوقت الموفَّر", override: "معدل التجاوز البشري", costPerOutcome: "التكلفة لكل نتيجة", roi: "العائد" },
    kpiHelp: {
      runs: "عدد مرات تشغيل الوكلاء خلال الفترة.",
      containment: "نسبة الحالات التي أنهاها الوكلاء دون تحويلها إلى شخص.",
      deflection: "نسبة الحالات الجديدة التي حلّها الوكلاء بأنفسهم — عمل لم يحتج الموظفون إلى تولّيه.",
      timeSaved: "الساعات التقديرية من وقت الموظفين التي وفّرها الوكلاء.",
      override: "عدد مرات تغيير شخص لما اقترحه الوكيل أو رفضه. الأقل أفضل.",
      costPerOutcome: "تكلفة النماذج مقسومة على عدد الحالات المحلولة.",
      roi: "قيمة الساعات الموفَّرة مقسومة على تكلفة النماذج. 3× تعني أن كل وحدة أُنفقت وفّرت ثلاثًا.",
    },
    kpiInfo: "ماذا يعني {{kpi}}؟",
    kpiShort: {
      containment: "ما أنهاه الوكلاء دون تحويله إلى شخص",
      deflection: "الطلبات الجديدة التي أنجزها الوكلاء بأنفسهم",
      override: "عدد مرات تعديل شخص لإجابة الوكيل",
    },
    noData: "لا توجد بيانات كافية بعد",
    roiEmpty: "لا توجد بيانات كافية بعد. يظهر العائد بعد أن يُنهي الوكلاء أعمالًا وتُعرف تكلفتها.",
    empty: "لم يعمل أي وكيل في هذه الفترة. جرّب فترة أطول.",
  },
};
